import './App.css';
import {
	BrowserRouter,
	Navigate,
	Outlet,
	Route,
	Routes,
	useLocation,
} from 'react-router-dom';
import Home from './pages/Home/Home';
import AddResident from './pages/AIModules/AddResident';
import CreateCareNote from './pages/CreateCareNote';
import CreateCarePlan from './pages/AIModules/CarePlan/CreateCarePlan';
import { ToastAlert } from './components/ToastAlert';
import UsersDashboard from './pages/SuperAdmin/UsersDashboard';
import Login from './pages/Login';
import { getAccessToken, getUserRole } from './Utils/AuthUtil';
import ResetPassword from './pages/ResetPassword';
import ForgotPassword from './pages/ForgotPassword';
import MedicalAssistant from './pages/AIModules/MedicalAssistant';
import DeleteAccountPage from './pages/DeleteAccountInstructions';
import CreateAccount from './pages/CreateAccount';
import InitialCarePlanMain from './pages/AIModules/InitialCarePlan/InitialCarePlanMain';
import FeedbackDashboard from './pages/SuperAdmin/FeedbackDashboard';
import DetailSummarizer from './pages/AIModules/DetailSummarizer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';
import SessionGuard from './components/SessionGuard';
import APIIntegration from './pages/APIIntegration';
import { USER_ROLES } from './Utils/Enums';
import AdminDashboard from './pages/UserManagement';
import SystemUsageDashboard from './pages/Home/SystemUsageDashboard';
import Resident360Dashboard from './pages/Home/Resident360Dashboard';
import AllResidentProfile from './pages/Residents/AllResidentProfile';
import CQCNotification from './pages/AIModules/CQCNotification';
import Settings from './pages/Settings';
import { CssBaseline } from '@mui/material';
import UserManagement from './pages/UserManagement';
import TemplateConfiguration from './pages/AIModules/TemplateConfiguration';
import ResidentProfile from './pages/Residents/ResidentProfile';
import CarePlanValidator from './pages/AIModules/CarePlanValidator';
import AdmissionAssessment from './pages/Residents/AdmissionAssessment';

function App() {
	return (
		<>
			<BrowserRouter>
				<SessionGuard />
				<Routes>
					<Route element={<AuthenticationRoutes />}>
						<Route path="/" element={<Login />} />
						<Route
							path="/reset/role/:roleId/key/:keyId/id/:userId"
							element={<ResetPassword />}
						/>
						<Route path="/reset" element={<ForgotPassword />} />
						<Route
							path="/deleteAccount"
							element={<DeleteAccountPage />}
						/>
						<Route
							path="/createAccount"
							element={<CreateAccount />}
						/>
						<Route
							path="/privacy-policy"
							element={<PrivacyPolicy />}
						/>
						<Route path="/terms-of-use" element={<TermsOfUse />} />
					</Route>
					<Route element={<SuperAdminRoutes />}>
						<Route path="/admin" element={<UsersDashboard />} />
						<Route
							path="/feedback"
							element={<FeedbackDashboard />}
						/>
					</Route>
					<Route element={<PrivateRoutes />}>
						{/* <Route path="/home" element={<Home />} /> */}
						<Route
							path="/home"
							element={<Resident360Dashboard />}
						/>
						<Route
							path="/systemUsage"
							element={<SystemUsageDashboard />}
						/>
						<Route
							path="/profiles/:residentId?"
							element={<AllResidentProfile />}
						/>
						<Route path="/addResident" element={<AddResident />} />
						<Route path="/careNote" element={<CreateCareNote />} />
						<Route
							path="/carePlan/:residentId?"
							element={<CreateCarePlan />}
						/>
						<Route
							path="/configuration"
							element={<TemplateConfiguration />}
						/>
						<Route
							path="/assistant"
							element={<MedicalAssistant />}
						/>
						<Route
							path="/initialCarePlan"
							element={<InitialCarePlanMain />}
						/>
						<Route
							path="/summarizer"
							element={<DetailSummarizer />}
						/>
						<Route
							path="/integration"
							element={<APIIntegration />}
						/>
						<Route path="/users" element={<UserManagement />} />
						<Route
							path="/notifications"
							element={<CQCNotification />}
						/>
						<Route path="/settings" element={<Settings />} />
						<Route
							path="/resident/:residentId?"
							element={<ResidentProfile />}
						/>
						<Route
							path="/planValidator"
							element={<CarePlanValidator />}
						/>
						<Route
							path="/admissionAssessment"
							element={<AdmissionAssessment />}
						/>
					</Route>
				</Routes>
			</BrowserRouter>
			<ToastAlert />
			<CssBaseline />
		</>
	);
}

function PrivateRoutes() {
	return getAccessToken() &&
		(parseInt(getUserRole()) === USER_ROLES.admin ||
			parseInt(getUserRole()) === USER_ROLES.staff) ? (
		<Outlet />
	) : (
		<Navigate to="/" />
	);
}

function SuperAdminRoutes() {
	return getAccessToken() &&
		parseInt(getUserRole()) === USER_ROLES.superAdmin ? (
		<Outlet />
	) : (
		<Navigate to="/" />
	);
}

function AuthenticationRoutes() {
	const location = useLocation();
	const path = location.pathname;
	const userRole = parseInt(getUserRole());

	if (getAccessToken()) {
		if (checkIsAllowedWhileLoggedIn(path)) {
			return <Outlet />;
		}

		if (userRole === USER_ROLES.admin || userRole === USER_ROLES.staff) {
			return <Navigate to="/home" />;
		}

		if (userRole === USER_ROLES.superAdmin) {
			return <Navigate to="/admin" />;
		}
	}

	return <Outlet />;
}

function checkIsAllowedWhileLoggedIn(path) {
	const routePaths = [
		'/reset/role/',
		'/privacy-policy',
		'/terms-of-use',
		'/deleteAccount',
	];

	for (let i = 0; i < routePaths.length; i++) {
		if (path.startsWith(routePaths[i])) {
			return true;
		}
	}
	return false;
}

export default App;
